// extracted by css-extract-rspack-plugin
export default {"FormContainer":"FormContainer-n6_PWw","formContainer":"FormContainer-n6_PWw","FormSerch":"FormSerch-ENp0Xu","formSerch":"FormSerch-ENp0Xu"};